import { iconForName } from "@/components/artifacts/iconForName.ts";
import { LocationDisplay } from "@/components/ui/location-display.tsx";
import type { ArtifactComponent } from "@/types/artifacts-view.ts";
import { ArrowRight } from "lucide-react";

type DiffComponentData = Extract<ArtifactComponent, { type: "diff" }>;

const FormattedValue = ({
  value,
  valueType,
}: {
  value: string;
  valueType: DiffComponentData["valueType"];
}) => {
  if (valueType === "location") return <LocationDisplay location={value} />;
  return <>{value}</>;
};

export const DiffBlock = ({ component }: { component: DiffComponentData }) => {
  const Icon = component.icon ? iconForName(component.icon) : null;
  return (
    <div className="flex flex-col gap-1">
      <div className="flex flex-row gap-2 items-center text-sm text-muted-foreground">
        {Icon ? <Icon className="size-4" /> : null}
        <span>{component.label}</span>
      </div>
      <div className="flex flex-row gap-2 items-center ml-6">
        {component.oldValue ? (
          <>
            <span className="text-sm line-through text-muted-foreground">
              <FormattedValue value={component.oldValue} valueType={component.valueType} />
            </span>
            <ArrowRight className="size-4 text-muted-foreground" />
          </>
        ) : null}
        <span className="text-sm font-medium">
          <FormattedValue value={component.newValue} valueType={component.valueType} />
        </span>
      </div>
    </div>
  );
};
